import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Theme } from 'scripts/react-components/themes/Theme'

const headerStyles = ({ theme }: Theme) => css`
  label: chat__component-header;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${theme.spacings.byte} ${theme.spacings.kilo};
`

const headerTitleStyles = ({ theme }: Theme) => css`
  label: chat__component-header__title;

  display: inline-flex;
  align-items: center;
`

const headerLogoStyles = ({ theme }: Theme) => css`
  label: chat__component-header__logo;

  display: inline-block;
  border-radius: ${theme.borderRadius.circle};
  background-color: ${theme.colors.white};
  margin-right: ${theme.spacings.byte};
  padding: ${theme.spacings.bit};
`

const headerButtonsStyles = ({ theme }: Theme) => css`
  label: chat__component-header__logo;

  a,
  a:hover {
    color: ${theme.colors.white};
    padding: 5px ${theme.spacings.byte};
  }
`
export const Header = styled('div')(headerStyles)
export const HeaderTitle = styled('span')(headerTitleStyles)
export const HeaderLogo = styled('span')(headerLogoStyles)
export const HeaderButtons = styled('span')(headerButtonsStyles)
